module.exports = __webpack_public_path__ + "static/media/back.bf0dd84c.svg";